import type { GetServerSidePropsContext } from 'next';
import { type TAppError } from 'utils/error';
import { logger } from 'utils/log';
import { $fetch } from 'utils/request';
import { GET_POPUP_INFO, RIBBON } from 'utils/routes';

export type DefaultNewsletterData = {
  title: string;
  text: string;
  closeBgColor?: string;
};

export async function getNewsletterDefaultData({ locale }: { locale?: string }) {
  if (!locale || ['int', 'default'].includes(locale)) {
    const error: TAppError = { code: 'client_error', message: `Invalid locale ${locale}` };
    logger.warn({ error });
    return null;
  }
  return await $fetch({ path: GET_POPUP_INFO, query: { profile: locale } });
}

type RibbonResponse = {
  countryGlobale: boolean;
  headerRibbonDetailResponse: {
    title: string;
    detail: string;
    nl: boolean;
    type: string;
    anchorId: string;
  }[];
};
export async function getRibbon({ profile, context }: { profile: string; context: GetServerSidePropsContext }) {
  try {
    const r = await $fetch<RibbonResponse>({ path: RIBBON, query: { profile } }, { context });

    let response = r.headerRibbonDetailResponse ?? null;

    const hasHeaderRibbon10 = r.headerRibbonDetailResponse?.find((item) => item.anchorId === 'header.ribbon.10');
    if (hasHeaderRibbon10) {
      response = r.headerRibbonDetailResponse.sort((item) => {
        if (item.anchorId === 'header.ribbon.10') {
          return -1;
        }
        return 0;
      });
    }
    return response;
  } catch (e) {
    return null;
  }
}
